/**
 * Componente SubscriptionSection
 * Wrapper para el formulario de suscripción
 */
import React from "react";
import MotionWrapper from "../../shared/components/MotionWrapper";
import SubscriptionForm from "./SubscriptionForm";

const SubscriptionSection = () => {
    return (
        <MotionWrapper
            sectionKey="suscripcion"
            className="absolute inset-0 flex flex-col items-center justify-center text-center bg-black bg-opacity-90 p-4"
        >
            <SubscriptionForm />
        </MotionWrapper>
    );
};

export default SubscriptionSection;
